module.exports = __webpack_public_path__ + "static/19-3c78ea1c363ab58e57eb9244716dded7.jpg";